import { render } from "./UploadCard.vue?vue&type=template&id=35ef9c67&ts=true"
import script from "./UploadCard.vue?vue&type=script&lang=ts"
export * from "./UploadCard.vue?vue&type=script&lang=ts"

import "./UploadCard.vue?vue&type=style&index=0&id=35ef9c67&lang=css"

import exportComponent from "/codebuild/output/src754147292/src/web-ext-galaxycorp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__